import React from "react";
import { ThreeDots } from "react-loader-spinner";

function Spinner() {
  return (
    <div
      style={{
        position: "absolute",
        top: 0,
        left: 0,
        bottom: 0,
        right: 0,
        zIndex: 1,
        display: "grid",
        placeItems: "center",
        backgroundColor: "#00000040",
      }}
    >
      <ThreeDots
        visible={true}
        height="80"
        width="80"
        color="#1976d2"
        radius="9"
        ariaLabel="three-dots-loading"
        wrapperStyle={{}}
        wrapperClass=""
      />
    </div>
  );
}

export default Spinner;
